import React, { useState, useEffect } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import axios from "axios";
import moment from "moment";

export default function OverTimeChart3() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userId = sessionStorage.getItem("userId");

    useEffect(() => {
        const fetchAttemptsCount = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await axios.get(`/user/performance-attempts-count/${userId}`);
                setData(response.data.data);
                console.log(response.data.data)
            } catch (error) {
                console.error("Error fetching attempts count:", error);
                setError("Failed to fetch attempts count");
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchAttemptsCount();
        }
    }, [userId]);

    if (loading) return <div>Loading number of questions attempted...</div>;
    if (error) return <div>Error loading number of questions attempted: {error}</div>;

    const formatDate = (dateStr) => moment(dateStr).format('YYYY-MM-DD');

    return (
        <div className="chart-container">
            <ResponsiveContainer width="100%" height={400}>
                <BarChart
                    data={data}
                    margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                    <XAxis
                        dataKey="date"
                        angle={-45}
                        textAnchor="end"
                        height={60}
                        tickFormatter={formatDate}
                    />
                    <YAxis allowDecimals={false} />
                    <Tooltip labelFormatter={(label) => `Date: ${formatDate(label)}`} />
                    <Legend verticalAlign="top" height={36} />
                    <Bar dataKey="yourAverage" fill="#2E7D32" name="Number of Attempts" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}